<ng-template [ngIf]="show">
  <div class="library-sorting" [class.mobile]="deviceService.isMobile()">
    <div class="sorting-wrap" [formGroup]="form">
      <div *ngIf="utilsService.isContentPage" class="label">{{'library.content-filter.sort' | translate}}:</div>
      <on-ui-select formControlName="order"
                    [placeholder]="'library.content-filter.choose-sorting' | translate"
                    [options]="sortingOptions">
      </on-ui-select>
    </div>
  </div>
</ng-template>
